<div class="container">
    <div class="card p-3">
        <h4>{{textDisplay}}</h4>
        <form class="">

            <div class="alert alert-info mt-2 mb-3 py-2 px-3 small" *ngIf="!questionBank.isPsychometricTestBank">
                <strong>Note:</strong> Maximum pool size is 1,000 per question bank.
            </div>

            <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
                <p id="modelError">{{modelError}}</p>
            </div>

            <!-- Show WebTest Question Bank Checkbox -->
            <div class="row mb-3" *ngIf="isSave">
                <div class="col">
                    <div class="form-group" style="display: contents;margin-top: 20px;">
                        <div class="custom-control custom-checkbox">
                            <input id="showWebTestQuestionBank" type="checkbox" class="custom-control-input"
                                [(ngModel)]="showWebTestQuestionBank" [ngModelOptions]="{ standalone: true }"
                                (change)="onShowWebTestQuestionBankChange()">
                            <label class="custom-control-label" for="showWebTestQuestionBank">
                                Show WebTest Question Banks
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Question Bank Dropdown -->
            <div class="row" *ngIf="isSave">
                <div class="mb-3 mr-0 col">
                    <div class="form-group">
                        <label class="form-label">Question Bank</label>
                        <ng-select class="form-select" [(ngModel)]="questionBank.questionBankID"
                            [ngModelOptions]="{ standalone: true }" (change)="onQuestionBankChange($event)">
                            <ng-option [value]="-1" disabled selected>Select Question Bank</ng-option>

                            <ng-option *ngFor="let qb of filteredQuestionBanks" [value]="qb.questionBankID">
                                <div class="d-flex flex-column">
                                    <span class="fw-semibold">
                                        {{ qb.name }}
                                        <small *ngIf="qb.isWebTestBank" class="ms-2 badge rounded-pill"
                                            [ngClass]="qb.isWebTestBank ? 'bg-primary' : 'bg-success'">
                                            {{ qb.isWebTestBank ? 'Web Test Bank' : 'Company Bank' }}
                                        </small>
                                    </span>
                                    <small class="text-muted">
                                        Category: {{ qb.category?.trim() ? qb.category : 'Not set' }}
                                        <span class="ms-2">| Total # Questions: {{ qb.isWebTestBank ? "--" :
                                            qb.totalNumberOfQuestions }}</span>
                                    </small>
                                </div>
                            </ng-option>
                        </ng-select>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="mb-3 mr-0 col">
                    <label class="form-label">Category</label>
                    <input class="form-control" type="text"
                        [value]="questionBank.category ? questionBank.category : 'Not set'" readonly />
                </div>
            </div>

            <div class="row">
                <div class="mb-3 mr-0 col">
                    <label class="form-label">Number Of Questions</label>
                    <input class="form-control" type="number" min="0" [(ngModel)]="questionBank.numberOfQuestions"
                        [ngModelOptions]="{ standalone: true }">
                </div>
                <div class="mb-3 mr-0 col" *ngIf="!questionBank.isPsychometricTestBank">
                    <label class="form-label">Question Bank Pool Size</label>
                    <input class="form-control" type="number" min="0" [(ngModel)]="questionBank.questionBankPoolSize"
                        [ngModelOptions]="{ standalone: true }" min="0" max="1000">
                </div>
            </div>

            <div class="row ml-1 mb-3" *ngIf="!isSave && !questionBank.isPsychometricTestBank">
                <div class="form-check col">
                    <input class="form-check-input" type="checkbox" id="disabledCheckbox"
                        [(ngModel)]="questionBank.disabled" [ngModelOptions]="{ standalone: true }">
                    <label class="form-check-label" for="disabledCheckbox">
                        Disabled
                    </label>
                </div>
            </div>

            <div class="row mt-3" *ngIf="!questionBank.isPsychometricTestBank">
                <div class="mb-3 mr-0 col" *ngIf="!isSave">
                    <input class="form-control bg-primary text-white" type="button" value="Update Exam Question Bank"
                        (click)="saveQuestionBank(true)">
                </div>
                <div class="mb-3 mr-0 col" *ngIf="isSave">
                    <input class="form-control bg-primary text-white" type="button" value="Add Exam Question Bank"
                        (click)="saveQuestionBank()">
                </div>
            </div>
        </form>
    </div>
</div>